import {LinkType} from '@services/resource/link-type';

export class StartupLinkResource {
  constructor(
    public link: string,
    public type: LinkType,
  ) {}
}
